import { render, staticRenderFns } from "./GiftDialog.vue?vue&type=template&id=47e7a41f"
import script from "./GiftDialog.vue?vue&type=script&lang=js"
export * from "./GiftDialog.vue?vue&type=script&lang=js"
import style0 from "./GiftDialog.vue?vue&type=style&index=0&id=47e7a41f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports